import { Route, Redirect } from 'react-router-dom';
import React from 'react';

function PrivateRoute({ component: Component, layout: Layout, authed, redirectPath, ...rest }) {
  return (
    <Route
      { ...rest }
      render={ (props) => {
        return (authed
          ? (
            <Layout { ...props }>
              <Component { ...props } />
            </Layout>
          )
          : <Redirect to={ { pathname: redirectPath || '/login', state: { from: props.location } } } />);
      } }
    />
  );
}

export default PrivateRoute;
